define('views/shared/form/input/email_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/email_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'blur input': 'validateEmail'
        },

        initialize: function(options){
            options = options || {};

            this.field = options.field;

            this.is_valid = false;
            this.error = false;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        getValue: function(){

            if(this.field.encrypt){
                return encrypt(this.$el.find('input').val());
            } else {
                return this.$el.find('input').val();
            }
            
        },

        validateEmail: function(e){
            var email = $(e.target).val();

            if(email == '' || !email){

                this.is_valid = false;
                this.error_feedback = this.field.error.empty;
                this.showError();

            } else if(!isEmail(email)){
                
                this.is_valid = false;
                this.error_feedback = this.field.error.invalid;
                this.showError();

            } else {
                
                if(this.field.exists){

                    this.is_valid = true;
                    this.removeError();
                    
                } else {

                    this.doesEmailExist(email);

                }

            }

        },

        doesEmailExist: function(email){
            var that = this;

            $.ajax({
                type : 'POST',
                url  : pf.userURL + '/SignUp',
                data : JSON.stringify({ Email: encrypt(email) }),
                async: false,
                contentType: 'application/json',
                success    : function(response){
                    var success = response.Success,
                        email_exists_signup = response.SignUpEmailExists,
                        user_exists = response.userExists;

                    if(user_exists == true){

                        that.error_feedback = that.field.error.exists;
                        that.showError();

                    } else if(email_exists_signup || success){

                        that.is_valid = true;

                        // TODO: Show generic error without error text
                        that.error_feedback = that.field.error.exists;
                        that.removeError();

                    } else {
                        that.is_valid = true;
                        that.removeError();
                    }

                },
                error: function(response){}
            });

        },

        showError: function(){
            var feedback = this.error_feedback || this.field.error.empty;

            this.error = true;
            this.$el.find('.js-form-input-feedback').html(feedback);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
        },

        close: function(){}
    });
});

